module.exports = __webpack_public_path__ + "static/desktops-8f59956494d1e50633d4d693dcb9a902.png";